export const rowTitleFormat = function (value) {
  if (!value) return '';
  value = value.toString();

  return window._.startCase(value.split('_').join(' '));
};

export const arrayValuesFormatter = (value) => {
  if (typeof value === 'object') {
    let g = Object.keys(value).map((i) => {
      const k = i.charAt(0).toUpperCase() + i.slice(1);
      return `${k}: ${value[i]}`;
    });

    return g.join(', *');
  }

  return value;
};



// WEBPACK FOOTER //
// ./src/filters/utils.js